import React, { useState, useEffect } from 'react';

function EventsPage() {
  const [liveEvents, setLiveEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [registeredEvents, setRegisteredEvents] = useState([]);

  useEffect(() => {
    const fetchApprovedEvents = async () => {
      try {
        setLoading(true);
        const res = await fetch('/api/events');
        if (res.ok) {
          const data = await res.json();
          const list = data.events || data || [];
          if (Array.isArray(list) && list.length > 0) {
            setLiveEvents(list);
          }
        }
      } catch (e) {
        console.error('Failed to load events', e);
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedEvents();

    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  // Default fallback events if none created yet
  const fallbackEvents = [
    {
      _id: '1',
      title: 'Mental Health Awareness Workshop',
      scheduledAt: new Date(Date.now() + 86400000 * 2).toISOString(),
      endsAt: new Date(Date.now() + 86400000 * 9).toISOString(),
      publishWeeks: 1,
      mode: 'online',
      location: 'Virtual Room',
      eventType: 'workshop',
      createdBy: { name: 'Dr. Sarah Johnson' },
      description: 'Join us for an interactive workshop on understanding mental health and wellness practices.',
    },
    {
      _id: '2',
      title: 'Stress Management & Mindfulness Seminar',
      scheduledAt: new Date(Date.now() + 86400000 * 5).toISOString(),
      endsAt: new Date(Date.now() + 86400000 * 19).toISOString(),
      publishWeeks: 2,
      mode: 'online',
      location: 'Online Webinar',
      eventType: 'seminar',
      createdBy: { name: 'Dr. Michael Chen' },
      description: 'Learn practical techniques for managing stress in daily life and work environment.',
    },
    {
      _id: '3',
      title: 'Meditation & Emotional Resilience Masterclass',
      scheduledAt: new Date(Date.now() + 86400000 * 8).toISOString(),
      endsAt: new Date(Date.now() + 86400000 * 36).toISOString(),
      publishWeeks: 4,
      mode: 'offline',
      location: 'City Wellness Center, 3rd Floor',
      eventType: 'event',
      createdBy: { name: 'Dr. Emma Wilson' },
      description: 'Deep dive into mindfulness techniques and meditation practices for lasting inner peace.',
    },
  ];

  const displayList = liveEvents.length > 0 ? liveEvents : fallbackEvents;

  const handleRegister = (eventId) => {
    if (!registeredEvents.includes(eventId)) {
      setRegisteredEvents([...registeredEvents, eventId]);
      alert('Successfully registered for the event! Check your email for details.');
    } else {
      setRegisteredEvents(registeredEvents.filter((id) => id !== eventId));
      alert('Unregistered from the event.');
    }
  };

  return (
    <>
      {/* Page Header Start (Hero Section) */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-2.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Events & Seminars</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Events</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Events Section Start */}
      <section className="events-section" style={{ padding: '60px 0 40px 0', background: '#fafbff' }}>
        <div className="container">
          <div className="row" style={{ gap: '32px 0' }}>
            {displayList.map((evt) => {
              const id = evt._id || evt.id;
              const startDateObj = evt.scheduledAt ? new Date(evt.scheduledAt) : null;
              const endDateObj = evt.endsAt
                ? new Date(evt.endsAt)
                : startDateObj
                ? new Date(startDateObj.getTime() + (evt.publishWeeks || 1) * 7 * 86400000)
                : null;

              const formattedStart = startDateObj
                ? startDateObj.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
                : 'TBD';
              const formattedStartTime = startDateObj
                ? startDateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                : '';

              const formattedEnd = endDateObj
                ? endDateObj.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
                : 'TBD';

              const weeks = evt.publishWeeks || 1;
              const isReg = registeredEvents.includes(id);

              return (
                <div className="col-md-4 d-flex align-items-stretch" key={id}>
                  <div
                    className="event-card"
                    style={{
                      background: '#ffffff',
                      borderRadius: '18px',
                      boxShadow: '0 8px 30px rgba(0,0,0,0.06)',
                      overflow: 'hidden',
                      marginBottom: '32px',
                      transition: 'box-shadow 0.2s, transform 0.2s',
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: '460px',
                      maxWidth: '380px',
                      width: '100%',
                      marginLeft: 'auto',
                      marginRight: 'auto',
                      border: '1.5px solid #eef2f6',
                      position: 'relative',
                    }}
                  >
                    <div style={{ width: '100%', height: '170px', overflow: 'hidden', position: 'relative' }}>
                      <img
                        src={'/assets/images/new_img/image_1776236302329.webp_image.png'}
                        alt={evt.title}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', filter: 'brightness(0.93) saturate(1.1)' }}
                      />
                      {/* Week Duration Badge */}
                      <span
                        style={{
                          position: 'absolute',
                          top: 12,
                          left: 12,
                          background: 'rgba(124, 58, 237, 0.9)',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: '12px',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          backdropFilter: 'blur(4px)',
                        }}
                      >
                        🗓️ {weeks} Week{weeks > 1 ? 's' : ''} Listing
                      </span>

                      {/* Mode Badge */}
                      <span
                        style={{
                          position: 'absolute',
                          top: 12,
                          right: 12,
                          background: evt.mode === 'online' ? 'rgba(16, 185, 129, 0.9)' : 'rgba(59, 130, 246, 0.9)',
                          color: '#ffffff',
                          fontWeight: 700,
                          fontSize: '12px',
                          padding: '4px 12px',
                          borderRadius: '20px',
                          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                          backdropFilter: 'blur(4px)',
                        }}
                      >
                        {evt.mode === 'online' ? '💻 Online' : '🏥 Venue'}
                      </span>
                    </div>

                    <div style={{ padding: '24px 22px 20px 22px', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                      <div>
                        {/* Event Category & Fee Row */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                          <div style={{ color: '#7c3aed', fontWeight: 700, fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            {evt.eventType || 'Seminar'}
                          </div>
                          <span
                            style={{
                              background: '#fef3c7',
                              color: '#92400e',
                              border: '1px solid #fde68a',
                              fontWeight: 800,
                              fontSize: '12px',
                              padding: '2px 10px',
                              borderRadius: '12px',
                            }}
                          >
                            🎟️ {evt.eventFee || 'Free'}
                          </span>
                        </div>

                        {/* Event Title */}
                        <h4 style={{ marginBottom: '12px', color: '#1e293b', fontWeight: 700, fontSize: '1.18rem', letterSpacing: '0.01em', lineHeight: 1.35 }}>
                          {evt.title}
                        </h4>

                        {/* Host Name */}
                        <div style={{ fontSize: '0.88rem', color: '#64748b', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span>👤</span>
                          <span style={{ fontWeight: 600, color: '#334155' }}>
                            {evt.createdBy?.name || 'Verified Practitioner'}
                          </span>
                        </div>

                        {/* Event Date & Time */}
                        <div style={{ background: '#f8fafc', padding: '12px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '14px', fontSize: '0.86rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#1e293b', fontWeight: 700 }}>
                            <span>📅 Event Date:</span>
                            <span>{formattedStart} {formattedStartTime && `at ${formattedStartTime}`}</span>
                          </div>
                        </div>

                        {/* Location */}
                        {evt.location && (
                          <div style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '12px' }}>
                            📍 {evt.location}
                          </div>
                        )}

                        <p style={{ fontSize: '0.9rem', color: '#475569', marginBottom: '18px', minHeight: '44px', lineHeight: 1.5 }}>
                          {evt.description || 'Join this wellness event to gain practical coping skills, mindfulness tools, and expert guidance.'}
                        </p>
                      </div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: 'auto' }}>
                        {evt.videoUrl && (
                          <a
                            href={evt.videoUrl}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              width: '100%',
                              padding: '10px',
                              background: '#f5f3ff',
                              border: '1.5px solid #c4b5fd',
                              color: '#7c3aed',
                              borderRadius: '10px',
                              fontWeight: 700,
                              fontSize: '0.86rem',
                              textAlign: 'center',
                              textDecoration: 'none',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              boxSizing: 'border-box',
                            }}
                          >
                            <span>🎬</span> Watch Event Video / Media ↗
                          </a>
                        )}

                        {evt.registrationLink ? (
                          <a
                            href={evt.registrationLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="thm-btn"
                            style={{
                              width: '100%',
                              background: 'linear-gradient(135deg, #7c3aed 0%, #6366f1 100%)',
                              border: 'none',
                              color: '#ffffff',
                              fontWeight: 700,
                              padding: '12px',
                              borderRadius: '10px',
                              textAlign: 'center',
                              textDecoration: 'none',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              boxSizing: 'border-box',
                            }}
                          >
                            <span>🔗</span> Register for Event ↗
                          </a>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleRegister(id)}
                            className="thm-btn"
                            style={{
                              width: '100%',
                              background: isReg ? '#10b981' : 'linear-gradient(135deg, #7c3aed 0%, #6366f1 100%)',
                              border: 'none',
                              color: '#ffffff',
                              fontWeight: 700,
                              padding: '12px',
                              borderRadius: '10px',
                              cursor: 'pointer',
                            }}
                          >
                            {isReg ? '✓ Registered' : 'Register for Event'}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Info Box */}
          <div className="row" style={{ marginTop: '50px' }}>
            <div className="col-lg-12">
              <div
                className="info-box wow fadeInUp"
                style={{
                  backgroundColor: '#fff',
                  padding: '30px',
                  borderRadius: '14px',
                  boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
                  borderLeft: '5px solid #7c3aed',
                }}
              >
                <h3 style={{ marginBottom: '12px', fontWeight: 800, color: '#1e293b' }}>📧 Get Event & Workshop Alerts</h3>
                <p style={{ marginBottom: '20px', color: '#64748b', fontSize: '0.95rem' }}>
                  Subscribe to receive real-time notifications about new mindfulness workshops, webinars, and therapeutic group sessions.
                </p>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    style={{
                      flex: 1,
                      minWidth: '250px',
                      padding: '12px 16px',
                      border: '1.5px solid #cbd5e1',
                      borderRadius: '8px',
                      fontFamily: 'inherit',
                      outline: 'none',
                    }}
                  />
                  <button
                    type="button"
                    style={{
                      padding: '12px 28px',
                      background: '#7c3aed',
                      color: '#ffffff',
                      fontWeight: 700,
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                    }}
                  >
                    Subscribe
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Events Section End */}
    </>
  );
}

export default EventsPage;
